import { Routes, Route, Navigate } from 'react-router-dom'

import ExternalApiAuditLogListView from 'Presentation/Views/ExternalApiAuditLog/List/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const ExternalApiAuditLogRoutes = () => (
  <Routes>
    <Route
      element={
        <ProtectedRoutePermission whitelist={RolePermissionConfigs.external_api_audit_log} />
      }>
      <Route index element={<ExternalApiAuditLogListView />} />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default ExternalApiAuditLogRoutes
